import { insights } from '../../services/algoliaService'
import localStorageCache from '../../utils/localStorageCache'
import { SEARCH_CONVERSION, SEARCH_TOKEN_URL } from '../../libs/config'
import getWithInMemoryCache from '../../utils/getWithInMemoryCache'

// @ts-expect-error  needs to be loaded differently, this is stil using legacy
module.exports = async function () {
  const content = localStorageCache.getItemAndRemove(SEARCH_CONVERSION) as {objectIDs: string[], positions: number[]}
  if (!content) return

  const CONVERSION_TIME = 30000
  const data: {client_id: string, token: string} = await getWithInMemoryCache(SEARCH_TOKEN_URL, {})

  insights('init', {
    appId: data.client_id,
    apiKey: data.token
  })

  setTimeout(function recordConversion () {
    insights('convertedObjectIDsAfterSearch', {
      ...content,
      eventName: `Search item read after ${CONVERSION_TIME / 1000}s`
    })
  }, CONVERSION_TIME)
}
